// extracted by mini-css-extract-plugin
export default {"smoothly_appear":"ui-story_smoothly_appear__izbuq","smoothly-appear":"ui-story_smoothly-appear__MMzi4"};